// extracted by mini-css-extract-plugin
export var externalLink = "_9x-0";
export var internalLinkLabel = "_9x-1";